import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';
import { isNil, Nillable } from '@web/utils';
import { DictionaryCollectionItemResponse } from '../../shared/api/responses/dictionary-collection-item.response';
import { AdminDictionaryProductAttributeApiService } from '../api/services/admin-dictionary-product-attribute-api.service';

@Injectable({
  providedIn: 'root',
})
export class AdminDictionaryProductAttributeSelectItemsProviderService {
  /* prettier-ignore */
  private readonly adminDictionaryApi = inject(AdminDictionaryProductAttributeApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchCollectionAsSelectItems<Key extends keyof DictionaryCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<DictionaryCollectionItemResponse[Key]>[]> {
    return this.adminDictionaryApi
      .fetchCollection(
        this.collectionRequestBuilder
          .sorts((builder) => [builder.ascendingFor('label').build()])
          .disablePagination()
          .build(),
        true,
      )
      .pipe(
        map(({ items }) =>
          items
            .filter(item => {
              if (isNil(query)) {
                return item;
              }

              return item.label.toLowerCase().includes(query);
            })
            .map((item) => new SelectItem(item.label, item[key])),
        ),
        catchError(() => of([])),
      );
  }
}
